import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  blogs: [],
  loading: false,
  error: null,
  blogDetails:{},
  totalPage:1
};

const blogSlice = createSlice({
  name: 'blog',
  initialState,
  reducers: {
    getBlogs(state) {
      state.loading = true;
    },
    getBlogsSuccess(state, action) {
      state.loading = false;
      state.blogs = action.payload.data;
      state.error = null;
      state.totalPage=action.payload.totalPages
    },
    getBlogsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getSingleBlog(state) {
      state.loading = true;
    },
    getSingleBlogSuccess(state, action) {
      state.loading = false;
      state.blogDetails = action.payload;
      state.error = null;
    },
    getSingleBlogFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { getBlogs, getBlogsSuccess, getBlogsFailure ,getSingleBlog,  getSingleBlogSuccess,
  getSingleBlogFailure} = blogSlice.actions;

export default blogSlice.reducer;
